import { useTranslation } from 'react-i18next';
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons/faAngleRight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { WidgetCard } from 'us-react-components/dist/WidgetCard/WidgetCard';
import { computed } from 'mobx';
import { getUrlWithScheme, splitTextIntoTwoParts } from '../../../../../utils';
import { useDependencies } from '../../../../../dependencies';
import { Button, ButtonType } from '../../../../Button';
import { Strings } from '../../../../../constants';

export const OutOfNetworkReimbursement = (): JSX.Element => {
  const { t } = useTranslation();
  const { stores } = useDependencies();
  const { oonDescription, oonFormUrl } = stores.parent;

  const urlWithScheme = computed(() => getUrlWithScheme(oonFormUrl)).get();

  const handleClick = (): void => {
    const newWindow = window.open(urlWithScheme, '_blank');
    newWindow?.focus();
  }

  const {
    firstPart: description,
    secondPart: moreDescription,
  } = computed(() => splitTextIntoTwoParts(oonDescription, Strings.DEFAULT_TRUNCATE_LIMIT)).get();

  return (
    <WidgetCard
      title={t('dashboard.widgets.outOfNetworkReimbursement.title')}
      description={description}
      moreDescription={moreDescription}
      hasButton
      buttonComponent={<Button
          buttonType={ButtonType.tertiary}
          onClick={handleClick}>{t('dashboard.widgets.outOfNetworkReimbursement.accessFormHere')}
          <FontAwesomeIcon icon={faAngleRight} className='pl-2 m-[-1px]' />
        </Button>
      }
    />
  );
};
